









































import {Component, Prop, Vue} from 'vue-property-decorator';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
@Component({
    components: {CNumberField, CCheckbox},
})
export default class EquipmentTableRow extends Vue {
    @Prop() data: any;
    @Prop() editing!: boolean;
}
